import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarOpenSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private sidebarOpenSubject$ = this.sidebarOpenSubject.asObservable();

  constructor() { }

  getSidebarOpen() {
    return this.sidebarOpenSubject$;
  }

  setSidebarOpen(value: boolean) {
    this.sidebarOpenSubject.next(value);
  }
}
